// removed by extract-text-webpack-plugin
module.exports = {"inappcard":"inappcard__2T6EsnVOX3t-","PaddedWrapper":"PaddedWrapper__TEp-LlTIt9zZ"};